window.theme = window.theme || {};

theme.recentlyViewed = (function() {
  const STORAGE_KEY = 'viewedProducts';
  const MAX_PRODUCTS = 16;

  function getProducts() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return [];

      const parsed = JSON.parse(stored);

      if (parsed.length > 0 && typeof parsed[0] === 'string') {
        localStorage.removeItem(STORAGE_KEY);
        return [];
      }

      return parsed;
    } catch (e) {
      return [];
    }
  }

  function getHandles() {
    return getProducts().map(p => p.handle).filter(Boolean);
  }

  function getIds() {
    return getProducts().map(p => p.id).filter(Boolean);
  }

  function addProduct(handle, id) {
    if (!handle) return;

    const product = { handle: String(handle), id: String(id || '') };
    let products = getProducts();

    products = products.filter(p => p.handle !== handle);
    products.unshift(product);
    products = products.slice(0, MAX_PRODUCTS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (e) {}
  }

  function clearProducts() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function hasProducts() {
    return getProducts().length > 0;
  }

  return {
    getProducts,
    getHandles,
    getIds,
    addProduct,
    clearProducts,
    hasProducts
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-recently-viewed-track]');
  if (el) theme.recentlyViewed?.addProduct(el.dataset.productHandle, el.dataset.productId);
});
